"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const cashpayment = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-cashpayment` : '') + (description ? ` desc-cashpayment` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-cashpayment"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-cashpayment"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36 0.129883C37.1046 0.129883 38 1.02531 38 2.12988V21.8799C38 22.9845 37.1046 23.8799 36 23.8799H2C0.89543 23.8799 0 22.9845 0 21.8799V2.12988C0 1.02531 0.89543 0.129883 2 0.129883H36ZM36 0.629883H2C1.2203 0.629883 0.579551 1.22477 0.506867 1.98542L0.5 2.12988V21.8799C0.5 22.6596 1.09489 23.3003 1.85554 23.373L2 23.3799H36C36.7797 23.3799 37.4204 22.785 37.4931 22.0243L37.5 21.8799V2.12988C37.5 1.35019 36.9051 0.709434 36.1445 0.636749L36 0.629883Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.4791 7.45496H18.3388C17.8566 7.45496 17.3942 7.6465 17.0532 7.98745C16.7123 8.3284 16.5208 8.79083 16.5208 9.27301C16.5208 12.0001 21.4791 12.0001 21.4791 14.7272C21.4791 15.2094 21.2875 15.6718 20.9466 16.0127C20.6056 16.3537 20.1432 16.5452 19.661 16.5452H16.5208",
    stroke: "black",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 7.45472V5.80194",
    stroke: "black",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 16.545V18.1978",
    stroke: "black",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = cashpayment;